// extracted by mini-css-extract-plugin
module.exports = {"footer":"w_bw","footerWrapper":"w_bx","companyAddress":"w_by","kofiLink":"w_bz","siteInfo":"w_bB","copyright":"w_bC","copyrightImage":"w_bD"};